
import { wclFetch } from "../helpers";

document.addEventListener('DOMContentLoaded', () => {
   const form = document.querySelector('#wcl-newsletter-form');

   if (!form) {
      return;
   }

   const body = form.closest('.wcl-newsletter-block__body');

   const message = body.querySelector('.wcl-newsletter-block__message');

   const submitButton = form.querySelector('[type="submit"]');
   const buttonText = submitButton?.querySelector('span');

   if (!message || !submitButton || !buttonText) {
      return;
   }

   form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const emailInput = form.querySelector('input[name="email"]');

      if (!emailInput) {
         return;
      }

      emailInput.value = emailInput.value.trim();

      if (!form.reportValidity()) {
         return;
      }

      const originalText = buttonText.textContent;

      submitButton.disabled = true;
      buttonText.textContent = 'Submitting...';

      message.textContent = '';
      message.classList.remove('is-success', 'is-error');

      try {
         const formData = new FormData(form);

         formData.set(
            'action',
            'wcl_campaign_monitor_subscribe'
         );

         const response = await wclFetch(formData);
         const result = await response.json();

         if (!response.ok || !result.success) {
            throw new Error(
               result.data?.message || 'Unable to subscribe. Please try again.'
            );
         }

         message.textContent = result.data.message;
         message.classList.add('is-success');

         form.reset();
      } catch (error) {
         message.textContent = error.message || 'Something went wrong. Please try again.';

         message.classList.add('is-error');
      } finally {
         submitButton.disabled = false;
         buttonText.textContent = originalText;
      }
   });
});